import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

/**
 * FilterByVisibility component
 * @param {Object} props
 * @param {number|string} props.value - Current selected value (1 or 0)
 * @param {function} props.onChange - Callback when value changes
 * @param {string} [props.label] - Optional label for the select
 */
const FilterByVisibility = ({ value, onChange, label = "Filter by Job Visibility" }) => {
  return (
    <FormControl fullWidth variant="outlined" size="small" sx={{ maxWidth: 180 }}>
      <InputLabel id="visibility-filter-label">{label}</InputLabel>
      <Select
        labelId="visibility-filter-label"
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    </FormControl>
  );
};

export default FilterByVisibility;
